import { render, staticRenderFns } from "./PageSettingsBackgroundImage.vue?vue&type=template&id=cb98f4e4"
import script from "./PageSettingsBackgroundImage.vue?vue&type=script&lang=ts"
export * from "./PageSettingsBackgroundImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports